import React from 'react';
import { BoundAutocomplete } from "../BoundAutocomplete";
import { AssetTypeLabel } from "../../../../constants/securspace-constants";

type BoundAssetTypeAutocompleteProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundAssetTypeAutocomplete = <T,>({
  label = "Asset Type",
  name,
  value = '',
  onChange
}: BoundAssetTypeAutocompleteProps<T>) => {

  return <BoundAutocomplete<T>
    options={AssetTypeLabel}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundAssetTypeAutocomplete };